/**
 * Condition Node Component
 * Displays a branching condition (diamond shape via styling).
 */
import { useTranslation } from "@/i18n";
import { cn } from "@/lib/utils";
import type { ConditionNodeData } from "./types";

interface ConditionNodeProps {
  node: ConditionNodeData;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

export function ConditionNode({ node, isSelected, onSelect }: ConditionNodeProps) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={() => onSelect(node.id)}
      className={cn(
        "flex flex-col items-center gap-1 rounded-lg border-2 px-4 py-3 text-center shadow-sm transition-colors max-w-[280px]",
        "bg-[var(--color-secondary)]/5 border-[var(--color-secondary)]/20 hover:border-[var(--color-secondary)]/40",
        isSelected && "ring-2 ring-[var(--color-secondary)] border-[var(--color-secondary)]/80",
      )}
    >
      <div className="text-xs font-medium text-[var(--color-secondary)] uppercase">
        {t("journey.node.condition")}
      </div>
      <div className="text-sm font-medium text-foreground truncate max-w-[240px]">
        {node.field} {t(`journey.condition.${node.operator}`)} {node.value}
      </div>
    </button>
  );
}
